export const TIME = {
    tenMinutes: 10 * 60 * 1000,
    tenSeconds: 10 * 1000,
    oneHour: 60 * 60 * 1000,
    twentySeconds: 20 * 1000,
}

export const roundTwoDecimals = (num: number): string => {
    return (Math.round(num * 100) / 100).toFixed(2)
}
